import PropTypes from "prop-types"

const plpPropsType = {
  handleOnClickPartsDiagramLink: PropTypes.func.isRequired,
  propsProductCard: PropTypes.shape({
    variantImages: PropTypes.arrayOf(PropTypes.string).isRequired,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      category: PropTypes.string,
      slug: PropTypes.string,
      productName: PropTypes.string,
      productColor: PropTypes.string,
      productStatus: PropTypes.bool,
      productSaleable: PropTypes.bool,
      productBasePrice: PropTypes.string,
      productSalePrice: PropTypes.string,
      globalPromotionPrice: PropTypes.string,
      priceState: PropTypes.string,
      productSuperSku: PropTypes.string,
      productTileName: PropTypes.string,
      defaultImageName: PropTypes.string,
      productCollectionsName: PropTypes.string,
      badgeValue: PropTypes.string,
      discountPercent: PropTypes.number,
      discountAmount: PropTypes.number,
      productIsRetail: PropTypes.bool,
      isBundleProduct: PropTypes.bool,
      colors: PropTypes.array,
      resourceName: PropTypes.string,
      productNo: PropTypes.string,
    }).isRequired,
    originaldata: PropTypes.shape({
      id: PropTypes.string,
      masterSKU_s: PropTypes.string,
      "Color.SKU.Details_ss": PropTypes.arrayOf(PropTypes.string),
      Collapse_Description_s: PropTypes.string,
      ProductDescriptionProductShort_s: PropTypes.string,
      masterCustomerFacingSKU_s: PropTypes.string,
      category1_s: PropTypes.string,
      Product_Category: PropTypes.string,
    }),
    customerFacingSKU: PropTypes.string,
    productDetails: PropTypes.shape({
      checkbox: PropTypes.shape({
        defaultChecked: PropTypes.bool,
        checked: PropTypes.bool,
        onClick: PropTypes.func,
        tooltip: PropTypes.shape({
          label: PropTypes.string,
          width: PropTypes.string,
        }),
      }),
      SKU: PropTypes.object,
      colorSwatches: PropTypes.object,
      additionalLink: PropTypes.object,
    }),
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
      onError: PropTypes.func,
      onClick: PropTypes.func,
    }),
    title: PropTypes.object,
    description: PropTypes.object,
    price: PropTypes.object,
    isSaved: PropTypes.bool,
    fullUrl: PropTypes.string,
    tileUrl: PropTypes.string,
  }).isRequired,
  index: PropTypes.number,
}

const productListContextPropsType = {
  children: PropTypes.node,
  data: PropTypes.any,
  eventHandler: PropTypes.any,
  plpData: PropTypes.object, // Add validation for plpData
  plpBadgeList: PropTypes.any,
  disableCommerce: PropTypes.any,
  swatchUrl: PropTypes.any,
  language: PropTypes.any,
  general: PropTypes.any,
  socialMediaConfigs: PropTypes.any,
  plpServletPath: PropTypes.any,
  featureFlags: PropTypes.any,
  facetQuery: PropTypes.any,
  sortQuery: PropTypes.any,
  locale: PropTypes.any,
  skuPrepend: PropTypes.any,
  plpPresetConfig: PropTypes.any,
}

const filtersUiPropTypes = {
  propsFilters: PropTypes.object,
  propsScroll: PropTypes.object,
  propsSortUI: PropTypes.object,
}

const sortUiPropTypes = {
  propsSortUI: PropTypes.object.isRequired,
}

const productListUIProps = {
  propsProductCard: PropTypes.array,
  propsPagination: PropTypes.object,
  propsSortUI: PropTypes.object,
  propsScroll: PropTypes.object,
  propsFilters: PropTypes.object,
  filterClass: PropTypes.string,
  tileClass: PropTypes.string,
  rowCols: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  smartCrop: PropTypes.bool,
  componentProps: PropTypes.object,
  getIsPresentOnDeviceStatus: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]),
  setPromoData: PropTypes.func,
  colVal: PropTypes.object,
  promoData: PropTypes.object,
  position: PropTypes.number,
  promoCols: PropTypes.object,
  partData: PropTypes.object,
  onCloseModal: PropTypes.func,
  svgFileMap: PropTypes.object,
  totalCount: PropTypes.number,
  handleOnClickPartsDiagramLink: PropTypes.func,
}

const listingPropTypes = {
  tmpData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  headertmp: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  footertmp: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ip: PropTypes.string,
  adobeAnalytic: PropTypes.any,
  globalScript: PropTypes.any,
  footerScript: PropTypes.any,
  analyticsData: PropTypes.any,
  datalayerPageName: PropTypes.string,
  plpData: PropTypes.any,
  plpBadgeList: PropTypes.any,
  disableCommerce: PropTypes.bool,
  swatchUrl: PropTypes.string,
  lang: PropTypes.string,
  general: PropTypes.object,
  socialMediaConfigs: PropTypes.object,
  plpServletPathArray: PropTypes.array,
  featureFlags: PropTypes.object,
  gbhDataLayerCustom: PropTypes.object,
  canonicalUrl: PropTypes.string,
  seoPageScript: PropTypes.string,
  breadCrumbApplicationJSonLd: PropTypes.string,
  seoProperties: PropTypes.object,
  pageData: PropTypes.object,
  siteName: PropTypes.string,
  query: PropTypes.object,
  templateName: PropTypes.string,
  locale: PropTypes.string,
  skuPrepend: PropTypes.string,
  plpPresetConfig: PropTypes.object,
}

export {
  plpPropsType,
  productListContextPropsType,
  filtersUiPropTypes,
  sortUiPropTypes,
  productListUIProps,
  listingPropTypes,
}
